export const CURRENT_VERSION = '2.0.7';
